const staticSubmissionFiltersOptions = {
  type: ['BOOK', 'SCRIPT', 'SERIES'],
  read: [false, true],
  response_status: [false, true],
  form: ['BOOK', 'Film', 'SCRIPT', 'TV'],
  priority: ['Available Material', 'General', 'Project Samples'],
};

export default staticSubmissionFiltersOptions;
